import styles from "./CustomStatus.module.scss";

interface Props {
  label: string;
  borderColor?: string;
  textColor?: string;
  bgColor?: string;
  className?: string;
}

export const CustomStatus = (props: Props) => {
  const { label, borderColor, textColor, bgColor = "transparent", className } = props;
  return (
    <div
      className={`${styles.statusWrapper} ${className ? className : ""}`}
      style={{
        color: textColor ? textColor : undefined,
        borderColor: borderColor ? borderColor : undefined,
        backgroundColor: bgColor ? bgColor : undefined,
      }}
    >
      {label}
    </div>
  );
};
